export const ID = '9e2b21be-28fb-46ee-9f40-bc38c004853d';

export const NAME = 'Navigation';
